import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MonitorPlay, Layers, Circle, Spade, ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';

const CanliCasino: React.FC = () => {
  const { t } = useTranslation();

  const categories = [
    {
      title: t('games:liveCasino.liveLobby.title'),
      description: t('games:liveCasino.liveLobby.description'),
      icon: MonitorPlay,
      path: '/canli-casino/lobi',
      color: 'from-red-500 to-rose-500'
    },
    {
      title: t('games:liveCasino.tableGames.title'),
      description: t('games:liveCasino.tableGames.description'),
      icon: Layers,
      path: '/canli-casino/masa-oyunlari',
      color: 'from-amber-500 to-yellow-500'
    },
    {
      title: t('games:liveCasino.roulette.title'),
      description: t('games:liveCasino.roulette.description'),
      icon: Circle,
      path: '/canli-casino/rulet',
      color: 'from-green-500 to-emerald-500'
    },
    {
      title: t('games:liveCasino.blackjack.title'),
      description: t('games:liveCasino.blackjack.description'),
      icon: Spade,
      path: '/canli-casino/blackjack',
      color: 'from-purple-500 to-violet-500'
    }
  ];

  return (
    <>
      <SEO
        title={t('games:liveCasino.seoTitle')}
        description={t('games:liveCasino.seoDescription')}
        url="/canli-casino"
      />
      <div className="min-h-screen bg-dark-900 pt-24 pb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              {t('games:liveCasino.title')}
            </h1>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">
              {t('games:liveCasino.description')}
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {categories.map((category, index) => {
              const Icon = category.icon;
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                >
                  <Link
                    to={category.path}
                    className="group block bg-dark-800/50 backdrop-blur-sm rounded-2xl p-6 border border-dark-700 hover:border-primary-500/50 transition-all duration-300 h-full"
                  >
                    <div className={`w-16 h-16 mx-auto mb-4 rounded-xl bg-gradient-to-r ${category.color} flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                      <Icon className="w-8 h-8 text-white" />
                    </div>
                    <h2 className="text-xl font-bold text-white text-center mb-2 group-hover:text-primary-400 transition-colors">
                      {category.title}
                    </h2>
                    <p className="text-gray-400 text-center text-sm mb-4">
                      {category.description}
                    </p>
                    <div className="flex items-center justify-center text-primary-400 group-hover:text-primary-300">
                      <span className="mr-2 text-sm">{t('common:buttons.discover')}</span>
                      <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                    </div>
                  </Link>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default CanliCasino;
